import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../../codegen/Localize';
import { DatabaseForGrouping,groupDatabasesAction } from '../../actions/databases/GroupDatabasesAction';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const GroupDatabasesEntityAction: IEntityAction<DatabaseForGrouping, {}> = {
  name: EntityActionNames.GroupDatabases,
  translateName: Messages.groupDatabases_action,
  isVisible: (items: DatabaseForGrouping[], state) => {
    const featureEnabled =
        CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) &&
        FeatureFlags.mergeDedupeDatabasesEnabled &&
        selectCatalogingOnSiteEnabled(state);
    const hasUngroupedItems = items.some(item => !item.isGrouped);
    return featureEnabled && hasUngroupedItems;
  },
  isClickable: (_, items) => {
    const hasOnlyUngroupedItems = items.every(item => !item.isGrouped);
    const connectionTypesMatch = items.every(item => item.connectionType === items[0].connectionType);
    return items.length > 1 && hasOnlyUngroupedItems && connectionTypesMatch;
  },
  createReduxAction: (items: DatabaseForGrouping[]) => {
    return groupDatabasesAction(items);
  }
};
